<template>
  <div>
    <!-- 操作区 -->
    <Card>
      <Button style="margin-left:10px;" type="primary" @click="draw()">绘制范围</Button>
      <Button style="margin-left:10px;" type="primary" @click="clearOverlays()">清除范围</Button>
      <Button style="margin-left:10px;" type="primary" @click="saveHurdle">保存</Button>
      回收人员：
      <Select v-model="updateRecoveryUserId" style="width:200px">
        <Option v-for="(item, index) in userList" :value="item.value" :key="index">{{ item.label }}</Option>
      </Select>
      <Button style="margin-left:10px;" type="primary" @click="transferMapRange">修改区域</Button>
    </Card>
    <!-- 地图 -->
    <div id="map-container" style="height: 70vh; width: 100%"></div>
  </div>
</template>

<script>
export default {
  name: "admin",
  data() {
    return {
      name: "draw",
      center: { lng: 116.6163470719684, lat: 35.45582592983 }, // 中心点坐标
      zoom: 13, // 缩放级别
      location: "济宁市",
      keyword: "",
      radioSelect: "none",
      styleOptions: {
        strokeColor: "#5E87DB", // 边线颜色
        fillColor: "#5E87DB", // 填充颜色。当参数为空时，圆形没有填充颜色
        strokeWeight: 2, // 边线宽度，以像素为单位
        strokeOpacity: 1, // 边线透明度，取值范围0-1
        fillOpacity: 0.2, // 填充透明度，取值范围0-1
      },
      styleOptions1: {
        strokeColor: "#7fdb5e", // 边线颜色
        fillColor: "#81db5e", // 填充颜色。当参数为空时，圆形没有填充颜色
        strokeWeight: 2, // 边线宽度，以像素为单位
        strokeOpacity: 1, // 边线透明度，取值范围0-1
        fillOpacity: 0.2, // 填充透明度，取值范围0-1
      },
      styleOptions2: {
        strokeColor: "#ff0000", // 边线颜色
        // fillColor: "#81db5e", // 填充颜色。当参数为空时，圆形没有填充颜色
        strokeWeight: 2, // 边线宽度，以像素为单位
        strokeOpacity: 1, // 边线透明度，取值范围0-1
        fillOpacity: 0.2, // 填充透明度，取值范围0-1
      },
      labelOptions: {
        borderRadius: "2px",
        background: "#FFFBCC",
        border: "1px solid #E1E1E1",
        color: "#703A04",
        fontSize: "12px",
        letterSpacing: "0",
        padding: "5px",
      },
      map: null, // 百度地图
      drawingManager: null, // 鼠标绘制工具
      localSearch: null, // 地区检索
      region: {}, // 行政区域
      regionId: '',
      pointsArr: [],
      recoveryUserId: '',
      updateRecoveryUserId: '',// 修改区域回收人员
      userList: [],
      params: {
        page: 1,
        rows: 20,
        isDisable: 0,
      }
    }
  },
  watch: {
    // 绘制类型变更
    radioSelect(nval, oval) {
      if (nval != "none") {
        this.clearOverlays();
        this.drawingManager.close();
        this.draw(nval);
      } else {
        this.drawingManager.close();
      }
    },
    // 地区检索关键字变更
    keyword(nval, oval) {
      this.localSearch.clearResults();
      this.localSearch.search(nval);
    },
  },
  mounted() {
    // 创建Map实例
    this.map = new BMap.Map("map-container", {
      enableMapClick: false,
      minZoom: 5,
      maxZoom: 19,
    });
    // 设置中心点坐标和地图级别
    this.map.centerAndZoom(
        new BMap.Point(this.center.lng, this.center.lat),
        this.zoom
    );
    // 开启鼠标滚轮缩放
    this.map.enableScrollWheelZoom(true);

    // 创建鼠标绘制工具
    this.drawingManager = new BMapLib.DrawingManager(this.map, {
      // isOpen: true, //是否开启绘制模式
      enableCalculate: true, // 绘制是否进行测距(画线时候)、测面(画圆、多边形、矩形)
      drawingToolOptions: {
        enableTips: true,
        customContainer: "selectbox_Drawing",
        hasCustomStyle: true,
        offset: new BMap.Size(5, 5), // 偏离值
        scale: 0.8, // 工具栏缩放比例
        drawingModes: [
          BMAP_DRAWING_RECTANGLE,
          BMAP_DRAWING_POLYGON,
          BMAP_DRAWING_CIRCLE,
        ],
      },
      enableSorption: true, // 是否开启边界吸附功能
      sorptionDistance: 20, // 边界吸附距离
      enableGpc: true, // 是否开启延边裁剪功能
      enbaleLimit: true, // 是否开启超限提示
      // limitOptions: {
      //     area: 50000000 // 面积超限值
      // },
      circleOptions: this.styleOptions, // 圆的样式
      polylineOptions: this.styleOptions, // 线的样式
      polygonOptions: this.styleOptions, // 多边形的样式
      rectangleOptions: this.styleOptions, // 矩形的样式
      labelOptions: this.labelOptions, // label的样式
    });

    // 实例化地区检索
    // this.localSearch = new BMap.LocalSearch(this.map, {
    //   renderOptions: { map: this.map, panel: "search-result" },
    // });

    // 加载围栏数据
    this.loadHurdle();
  },

  created() {
    // 回收范围
    this.pointsArr = this.$route.query.pointsArr
    // 回收员id
    this.recoveryUserId = this.$route.query.recoveryUserId
    // 查询运营商运营范围
    this.findTenantRang();
    // 查询所有回收员列表
    this.findList();
  },
  methods: {
    // 清除地图覆盖物
    clearOverlays() {
      const overlays = this.map.getOverlays();
      console.log('overlays', overlays)
      for (let i = overlays.length - 1; i >= 0; i--) {
        const overlay = overlays[i];
        if (overlay['customType'] !=='other') {
          this.map.removeOverlay(overlay);
        }
      }
      //   overlays.forEach((item) => {
      //     console.log('item', item)
      //     if (item.customType !== 'other') {
      //       this.map.removeOverlay(overlay);
      //     }
      //   });
      // this.map.clearOverlays();
    },

    // 绘制多边形
    draw() {
     // this.clearOverlays();
      this.drawingManager.close();

      // var arr = document.getElementsByClassName("bmap-btn");
      // console.log('111', arr);
      // for (var i = 0; i < arr.length; i++) {
      //   arr[i].style.backgroundPositionY = "0";
      // }

      // 绘制类型为多边形
      var drawingType = BMAP_DRAWING_POLYGON;

      // 进行绘制
      if (this.drawingManager._isOpen && this.drawingManager.getDrawingMode() === drawingType) {
        this.drawingManager.close();
      } else {
        this.drawingManager.setDrawingMode(drawingType);
        this.drawingManager.open();
      }
    },

    // 绘制行政区域
    // drawRegion() {
    //   if (!this.region.value) {
    //     this.$message({
    //       message: "操作失败，请选择区域",
    //       type: "error",
    //     });
    //     return;
    //   }
    //   this.radioSelect = "none";
    //   var bdary = new BMap.Boundary();
    //   bdary.get(this.region.value, (rs) => {
    //     //获取行政区域
    //     this.map.clearOverlays(); //清除地图覆盖物
    //     var count = rs.boundaries.length; //行政区域的点有多少个
    //     if (count === 0) {
    //       alert("未能获取当前输入行政区域");
    //       return;
    //     }
    //     var pointArray = [];
    //     for (var i = 0; i < count; i++) {
    //       console.log(rs.boundaries[i]);
    //       var ply = new BMap.Polygon(rs.boundaries[i], this.styleOptions); //建立多边形覆盖物
    //       var str = JSON.stringify(ply.ia); //将BMap获取的行政区边界经纬度转为字符串
    //       this.map.addOverlay(ply); //添加覆盖物
    //       pointArray = pointArray.concat(ply.getPath());
    //     }
    //     this.map.setViewport(pointArray); //调整视野
    //   });
    // },

    // 加载围栏数据
    async loadHurdle() {
      if (this.pointsArr) {
        const pointsArr = JSON.parse(this.pointsArr);
        // const pointsArr = ["116.6030521504202,35.42615367805991;116.62978572239713,35.42662427409829;116.63021690904192,35.4140348746259;116.60362706594658,35.41279935931428"]
        if (pointsArr && pointsArr.length > 0) {
          var pathArr = [];
          pointsArr.forEach((item) => {
            var ply = new BMap.Polygon(item, this.styleOptions1); //建立多边形覆盖物
            ply['customType'] = 'unique'
            this.map.addOverlay(ply); //添加覆盖物
            pathArr = pathArr.concat(ply.getPath());
            ply.enableEditing();// 开启编辑模式
          });
          this.map.setViewport(pathArr); //调整视野
        }
      }
    },

    // 保存围栏数据
    saveHurdle() {
      var overlays = this.map.getOverlays();
      console.log('地图上的覆盖物数量:', overlays.length);
      var pointsStrArr = [];
      overlays.forEach((item) => {
        console.log('item', item)
        if (item.customType !== 'other') {
          if (item.getPath) {
            var pointsStr = this.pointsToStr(item.getPath());
            pointsStr && pointsStrArr.push(pointsStr);
          }
        }
      });
      console.log('pointsStrArr', pointsStrArr);
      if (pointsStrArr.length == 0) {
      //   this.$Message.error('操作失败，您没用绘制任何有效区域');
      //   return;
        // 后台保存需要的路径坐标数据
        const data = JSON.stringify(pointsStrArr);
        this.updateRange(data);
      } else {
        // 后台保存需要的路径坐标数据
        const data = JSON.stringify([pointsStrArr[0]]);
        this.updateRange(data);
      }
    },

    // 坐标点数组转字符串
    pointsToStr(points) {
      if (!points) return "";
      var str = "";
      points.forEach((item) => {
        str += item.lng + "," + item.lat + ";";
      });
      return str.slice(0, -1);
    },
    // 更新地图范围
    updateRange(range) {
      if ("[]"=== range) {
        range = ""
      }
      let params = {
        recoveryUserId: this.recoveryUserId,
        mapRange: range
      }
      this.axios.post('/recoveryUser/updateMapRange', params).then(res => {
        console.log(res);
        if (res.status == 200) {
          this.$Message.success('保存回收范围成功');
          this.$router.push({path: '/index/recycler'})
        }
        if(res.status == 201){
          this.$Message.error(res.msg);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '保存回收区域接口报错',
            duration: 0
          });
        }
      })
    },
    // 回收员-列表查询
    findList() {
      this.axios.post('/recoveryUser/findList', this.params).then(res => {
        if (res.status == 200) {
          this.total = res.data.total;
          this.data = res.data.rows;
          console.log('data,,,,', this.data)
          if (this.data) {
            this.userList = []
            this.data.forEach(v => {
              let object = {
                value: v.recoveryUserId,
                label: v.realName,
                mapRange: v.mapRange
              }
              this.userList.push(object)
              // 回显其他人运营范围，排除当前回收人员
              if (v.recoveryUserId !== this.recoveryUserId) {
                if (v.mapRange) {
                  const pointsArr = JSON.parse(v.mapRange);
                  if (pointsArr && pointsArr.length > 0) {
                    var pathArr = [];
                    pointsArr.forEach((item) => {
                      var ply = new BMap.Polygon(item, this.styleOptions); //建立多边形覆盖物
                      ply['customType'] = 'other'
                      this.map.addOverlay(ply); //添加覆盖物
                      pathArr = pathArr.concat(ply.getPath());
                    });
                    this.map.setViewport(pathArr); //调整视野
                  }
                }
              }
            })
          }
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询回收员列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 查询运营商运营范围
    findTenantRang() {
      this.axios.post('/range/findRangeList').then(res => {
        if (res.status == 200) {
          if (res.data && res.data[0].mapRange) {
            const pointsArr = JSON.parse(res.data[0].mapRange);
            if (pointsArr && pointsArr.length > 0) {
              var pathArr = [];
              pointsArr.forEach((item) => {
                var ply = new BMap.Polygon(item, this.styleOptions2); //建立多边形覆盖物
                ply['customType'] = 'other'
                this.map.addOverlay(ply); //添加覆盖物
                pathArr = pathArr.concat(ply.getPath());
              });
              this.map.setViewport(pathArr); //调整视野
            }
          }
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询运营商运营范围接口报错',
            duration: 0
          });
        }
      })
    },

    // 转移区域
    transferMapRange() {
      let params = {
        recoveryUserId: this.recoveryUserId,
        transferRecoveryUserId: this.updateRecoveryUserId
      }
      this.axios.post('/recoveryUser/transferMapRange', params).then(res => {
        console.log(res);
        if (res.status == 200) {
          this.$Message.success('修改回收范围成功.');
          this.$router.push({path: '/index/recycler'})
        }
        if(res.status == 201){
          this.$Message.error(res.msg);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '修改回收区域接口报错',
            duration: 0
          });
        }
      })
    }
  },
  components: {
  }
}
</script>

<style scoped>

#map-container {
  width: 100%;
  height: 100%;
}

/*.el-radio-button.is-active .s-icon.s-icon-rectangle {*/
/*  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkBAMAAACCzIhnAAAAJFBMVEUAAAD///////////////////////////////////////////+0CY3pAAAAC3RSTlMAGjFNX32CoLPO5hUiNAEAAAABYktHRAsf18TAAAAAqklEQVRYw2NgGAWkg1mrIKAAtxJ2qJKVUP7q3RDQgFsLB1TJLjprURQUFPTGr2ULUIkQkhYBIGmNX8tmIMmIoQUvGGJayPA+SVqcjY2Ns/Fr2QZUYkL3BEOyloqOjt27Ozo6AnBrYe2AqGlHCO3eTTgnoqkZ1TKqZVTLqJZRLaNaRrWMahnVMqploLSQ0egdxJ1EMjoj9OkljfB+JRmd90GaxsgYVBkFpAAAyZJmP55ExscAAAAASUVORK5CYII=);*/
/*}*/
</style>
